import React, { useState, useEffect } from "react";
import "./Evento.css";
import "./forms.css";
import AccessTimeIcon from "@mui/icons-material/CalendarTodayOutlined";
import LocationOnIcon from "@mui/icons-material/LocationOnOutlined";
import LinkIcon from "@mui/icons-material/Link";
import NorthEastIcon from "@mui/icons-material/NorthEast";
import Grid from "@mui/material/Grid";
import Box from "@mui/joy/Box";
import Card from "@mui/joy/Card";
import CardCover from "@mui/joy/CardCover";
import CardContent from "@mui/joy/CardContent";
import Typography from "@mui/joy/Typography";
import { urlRoot } from "../global";

const DateDisplay = ({ date }) => {
  // Asegurarnos de que el string de fecha se interprete como hora local y no aplique offset de UTC
  const dateString = String(date).replace('Z', '').replace('T', ' ').split('.')[0];
  const safeDateString = dateString.replace(/-/g, '/'); // Formato YYYY/MM/DD HH:mm:ss para evitar problemas en distintos navegadores
  
  const formattedDate = new Date(safeDateString);
  
  // Obtener el día, el mes y el año por separado
  const day = formattedDate.getDate();
  const locale = "es";
  const month = formattedDate.toLocaleString(locale, { month: "long" });
  const year = formattedDate.getFullYear();
  const hours = formattedDate.getHours();
  const minutes = formattedDate.getMinutes();
  const ampm = hours >= 12 ? "pm" : "am";

  // Convierte la hora a formato de 12 horas
  const hour12 = hours % 12 || 12;
  let hourShow = hour12;
  if (hourShow < 10) hourShow = "0" + hourShow;

  let minutesShow = minutes;
  if (minutesShow < 10) minutesShow = "0" + minutesShow;

  return (
    <div>
      <p className="fechaEvent">{`${day} de ${month} de ${year} | ${hourShow}:${minutesShow} ${ampm} hora del centro de México.`}</p>
    </div>
  );
};

function Evento({
  EventoNormal,
  Evento,
  Registrado,
  InfoCampus,
  InfoArea,
  btnshow,
  EventoExterno,
  tipoEvento,
  eventoPrivado,
}) {
  //console.log(Evento);
  //console.log(InfoArea['nombre']);
  //console.log(InfoArea["color"]);

  const [mustraDatos, setmustraDatos] = useState(true);
  //console.log(InfoCampus[0]['admissions_email']);

  const metaTag = document.querySelector("meta[name='keywords']");
  const metaDesc = document.querySelector("meta[name='description']");
  const metaTitle = document.querySelector("meta[property='og:title']");
  const metaDescOg = document.querySelector("meta[property='og:description']");
  const metaImg = document.querySelector("meta[property='og:image']");
  const metaName = document.querySelector("meta[property='og:site_name']");

  let areaNombre = InfoArea["name"];
  if (Object.keys(InfoCampus).length === 0) {
  } else {
    //console.log("si tiene info")

    if (areaNombre === undefined)
      areaNombre = ''

    if (metaTag)
      metaTag.setAttribute("content", InfoCampus[0].grade + ', ' + InfoCampus[0].name + ', ' + Evento[0].event.experience + ', ' + areaNombre);


    const stripHTML = (htmlString) => {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlString;
      return tempDiv.textContent || tempDiv.innerText || "";
    };

const descriptionText = stripHTML(Evento[0].event.description_text);
const titleText = stripHTML(Evento[0].event.title);
const imagenEvento = stripHTML(Evento[0].event.imagen);


  if (metaDesc)
    metaDesc.setAttribute("content",descriptionText);

  if(metaTitle)
    metaTitle.setAttribute("content",titleText);

  if(metaDescOg)
    metaDescOg.setAttribute("content",descriptionText);

  if(metaImg)
    metaImg.setAttribute("content","https://admision.tec.mx/a/img/eventos/"+imagenEvento);

  if(metaName)
    metaName.setAttribute("content",titleText);
  
  }

  useEffect(() => {
    if (tipoEvento === "902106") {
      setmustraDatos(false);
    }
  }, [tipoEvento]);

  var ruta = window.location.origin;
  var palabra = "localhost";
  var index = ruta.indexOf(palabra);
  if (index < 0) ruta = ruta + "/" + urlRoot;

  //const keymap = "";

  return (
    <Box sx={{ flexGrow: 1, paddingLeft: { xs: 2, sm: 4, md: "8%" }, paddingRight: { xs: 2, sm: 4, md: "8%" } }}>
      <Grid container spacing={2}>
        {Evento.map((eventos) => (
          <>
            {/*Titulo*/}
            <Grid item xs={12} sx={{ order: { xs: 1, md: 1 } }}>
              <h1 className="titleEvent">{eventos.event.title}</h1>
            </Grid>

            {/*Botón móvil (solo visible en xs)*/}
            {btnshow && (
              <Grid
                item
                xs={12}
                sx={{
                  display: { xs: "flex", md: "none" },
                  justifyContent: "center",
                  order: { xs: 2, md: 2 },
                }}
              >
                <a
                  href={
                    !EventoExterno ? "#btnValidaR" : eventos.event.room_number
                  }
                  target={!EventoExterno ? "" : "_blank"}
                  rel="noreferrer"
                  className="scroll-link"
                >
                  <button type="button" className="titregL">
                    <NorthEastIcon sx={{ fontSize: 20 }} />
                    REGÍSTRATE
                  </button>
                </a>
              </Grid>
            )}

            {/*Texto y Botón de registro*/}
            <Grid item md={7} lg={7} xs={12} sx={{ order: { xs: 4, md: 2 } }}>
              <p
                className="desEvent"
                dangerouslySetInnerHTML={{
                  __html: eventos.event.description_text,
                }}
              />
              <br></br>

              {btnshow && (
                <Grid spacing={2} sx={{ mt: 2, display: { xs: "none", md: "block" } }}>
                  <a
                    href={
                      !EventoExterno ? "#btnValidaR" : eventos.event.room_number
                    }
                    target={!EventoExterno ? "" : "_blank"}
                    rel="noreferrer"
                    className="scroll-link"
                  >
                    <button type="button" className="titregL">
                      <NorthEastIcon sx={{ fontSize: 20 }} />
                      REGÍSTRATE
                    </button>
                  </a>
                </Grid>
              )}

              {mustraDatos && (
              <Grid sx={{ pt: 3, mt: 2 }}>
                <div className="hour_date_container">
                  <span>
                    <AccessTimeIcon />
                  </span>
                  <DateDisplay date={eventos.event.fecha_evento} />
                </div>

                {!EventoExterno ? (
                  <div>

                    {eventos.event.experience === "linea" ? (
                      <p className="fechaEvent">
                        Evento en línea | Regístrate para obtener el link
                      </p>
                    ) : null}
                    {eventos.event.experience === "presencial" ? (
                      <div className="place_container">
                        <span>
                          <LocationOnIcon />
                        </span>
                        {eventos.event.experience === "linea" ? (
                          <>
                            <a
                              href={eventos.event.room_number}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {eventos.event.room_number}
                            </a>
                          </>
                        ) : (
                          <p className="fechaEvent">{eventos.event.room_number}</p>
                        )}
                      </div>
                    ) : null}
                    {eventos.event.experience === "hibrido" ? (
                      <div>
                        <p className="fechaEvent">
                          Evento híbrido | Regístrate para obtener el link
                        </p>
                        <div className="place_container">
                          <span>
                            <LocationOnIcon />
                          </span>
                          <p className="fechaEvent">{eventos.event.room_number}</p>
                        </div>
                      </div>
                    ) : null}
                    {eventos.event.experience === "linea" && Registrado === true ? (
                      <div className="meeting_link_container">
                        <span>
                          <LinkIcon />
                        </span>
                        <p className="fechaEvent">{eventos.event.stream_url}</p>
                      </div>
                    ) : null}
                  </div>
                ) : null}
              </Grid>
              )}
            </Grid>

            {/*Imagen del evento*/}
            <Grid
              item
              md={5}
              lg={5}
              xs={12}
              sx={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: { xs: "center", md: "flex-start" },
                order: { xs: 3, md: 3 },
              }}
            >
              <Box
                component="ul"
                sx={{
                  display: "flex",
                  gap: 2,
                  flexWrap: "wrap",
                  p: 0,
                  m: 0,
                  width: "100%",
                  justifyContent: { xs: "center", md: "flex-start" },
                }}
              >
                <Card
                  component="li"
                  md={5}
                  lg={5}
                  sx={{
                    minHeight: { xs: "160px", sm: "220px", md: "280px" },
                    width: { xs: "100%", md: 500 },
                    maxWidth: { xs: "280px", sm: "360px", md: "none" },
                    margin: { xs: "0 auto", md: "0" },
                    border: 'none', boxShadow: 'none' 
                  }}
                >
                  <CardCover
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "flex-start",
                      height: "100%",
                    }}
                  >
                    <img
                      src={ruta + "/img/eventos/" + eventos.event.imagen}
                      srcSet={ruta + "/img/eventos/" + eventos.event.imagen}
                      loading="lazy"
                      alt=""
                      className="evento-img"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        display: "block",
                        margin: "0",
                        objectFit: "contain",
                      }}
                    />
                  </CardCover>
                  <CardContent>
                    <Typography
                      level="body-lg"
                      fontWeight="lg"
                      textColor="#fff"
                      mt={{ xs: 4, sm: 10, md: 18 }}
                    >
                      .
                    </Typography>
                  </CardContent>
                </Card>
              </Box>
            </Grid>
          </>
        ))}
      </Grid>
    </Box>
  );
}

export { Evento };
